import React, { useState, useEffect } from 'react';
import PopProduct from './PopProduct';
import './popAnimation.less'


const PopAnimation = ({ onAnimationStart }) => {
    const [animationStarted, setAnimationStarted] = useState(false);
    const [animationFinished, setAnimationFinished] = useState(false);

    const startAnimation = () => {
        setAnimationStarted(true);
        onAnimationStart();
    };

    const handleAnimationFinish = () => {
        setAnimationFinished(true);
    };

    const imagesUrl = "https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/spriteBalao-min.png";

    return (
        <div>
            {!animationStarted &&
                <div onClick={startAnimation} style={{ width: '380px', height: '424px', overflow: 'hidden' }}>
                    <img className='sprite-ballon-animation' src={imagesUrl} alt="Balloon Sprite"/>
                </div>
            }
            {animationStarted && !animationFinished && <AnimatedBalloon onAnimationFinish={handleAnimationFinish} />}
            {animationFinished && <PopProduct />}
        </div>
    );
};

const AnimatedBalloon = ({ onAnimationFinish }) => {
    const [currentFrame, setCurrentFrame] = useState(0);
    const frameWidth = 489; // Largura de cada quadro do sprite
    const imagesUrl = "https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/spriteBalao-min.png";

    useEffect(() => {
        const animationInterval = setInterval(() => {
            if (currentFrame >= 15) {
                clearInterval(animationInterval);
                onAnimationFinish();
                return;
            }

            setCurrentFrame(prevFrame => prevFrame + 1);
        }, 130);

        return () => clearInterval(animationInterval);
    }, [currentFrame, onAnimationFinish]);

    return (
        <div style={{ width: `${frameWidth}px`, height: '564px', overflow: 'hidden' }}>
            <img src={imagesUrl} alt="Balloon Sprite" style={{ marginLeft: `-${currentFrame * frameWidth}px` }} />
        </div>
    );
};



export default PopAnimation;
